jQuery(document).ready(function ($) {
    //----------------------------Header Menu Burger Button Action-----------------------------------//
    $('.mobile_menu_icon').on('click', function () {
        $(this).toggleClass('active');
        $('.header__top').toggleClass('mobile_active');
        $('.header').toggleClass('mobile_active');
        if (window.innerWidth <= 1024) {
            $('body').toggleClass('no-scroll');
        }

        $(window).resize(function () {
            $('body').removeClass('no-scroll');
            if (window.innerWidth <= 1024 && document.querySelector('.header__top').classList.contains('mobile_active')) {
                $('body').addClass('no-scroll');
            }
        });

        $('.mobile_menu_bg').toggleClass('visible');
    });

    //-----------------------------------Header Height to the Main tag (reason is a fixed header menu)-----------------------------------//
    const headerEl = document.querySelector('.header__top');
    const mainEl = document.querySelector('main');
    const headerHeight = headerEl.offsetHeight;
    mainEl.style.paddingTop = `${headerHeight}px`;

    //----------------------------------------------Lang Switcher-----------------------------------//
    $('.lang-block-wrapper').click(function () {
        $('.lang-block-wrapper').toggleClass('active');
    });
    $(document).on('mouseup', function (e) {
        var s = $('.lang-block-wrapper.active');
        if (!s.is(e.target) && s.has(e.target).length === 0) {
            s.removeClass('active');
        }
    });

});

function headerMenuClassToggle() {
    if (window.innerWidth <= 1025 && !document.querySelector('header').classList.contains('mobile-device')) {
        document.querySelector('header').classList.add('mobile-device');
    } else if (window.innerWidth > 1025 && document.querySelector('header').classList.contains('mobile-device')) {
        document.querySelector('header').classList.remove('mobile-device');
    }
}

addEventListener("resize", (event) => {
    headerMenuClassToggle();
});

addEventListener("DOMContentLoaded", (event) => {
    headerMenuClassToggle();
});